import {
	CASH_UPDATES,
	LEVELS_TO_UNLOCK_CUSTOMERS,
	COMPONENTS_NAMES,
	LEVELS_TO_UNLOCK_FEATURES
} from '~/lib/constants';
import { levelSelectors, hintSelectors, turnSelectors, financialStatementsSelectors } from '~/store/selectors';
import LOGBOOK_TABS from '~/containers/logbook/log-tabs.enum';
import FINANCIAL_STATEMENTS_TABS from '~/containers/financial-statments/TabEnum'
// ---- internal imports ----


export function getExpenses(state) {
	return state.ui.cashUpdates.updates.filter((update) => update.type === CASH_UPDATES.EXPENSE);

}
export function getActiveModal(state) {
	return state.ui.activeModal;
}

export function getPreviouslyActiveModal(state){
	return state?.ui?.previouslyActiveModal;
}

export function getGameMenuReturnRoute(state) {
	return state.ui.gameMenuReturnRoute;
}

export function isLevelFailedReviewMode(state) {
	return state.ui.levelFailedReviewMode;
}

export function shouldShowNetworkErrorModal(state) {
	return state.ui.showNetworkErrorModal;
}

export function shouldDisplayPowerModalForProcurementScreen(state) {
	return state.ui.shouldDisplayPowerModalForProcurementScreen;
}

export function shouldDisplayPowerModalForHrScreen(state) {
	return state.ui.shouldDisplayPowerModalForHrScreen;
}

export function getCashUpdatesToBeDisplayed(state) {
	return state.ui.cashUpdates.updates;
}

export function isProfitDistributionLocked(state) {
	return levelSelectors.getLevelNumber(state) < LEVELS_TO_UNLOCK_FEATURES.PROFIT_DISTRIBUTION;
}

export function isCreditCustomersLocked(state) {
	return levelSelectors.getLevelNumber(state) < LEVELS_TO_UNLOCK_CUSTOMERS.CREDIT;
}

export function isTradeshowLocked(state) {
	return levelSelectors.getLevelNumber(state) < LEVELS_TO_UNLOCK_FEATURES.TRADESHOWS;
}

export function isHumanResourcesLocked(state) {
	return levelSelectors.getLevelNumber(state) < LEVELS_TO_UNLOCK_FEATURES.HUMAN_RESOURCES;
}

export function isAdsMagazineLocked(state) {
	return levelSelectors.getLevelNumber(state) < LEVELS_TO_UNLOCK_FEATURES.MAGAZINE_ADS;
}

export function isCarLocked(state) {
	return levelSelectors.getLevelNumber(state) < LEVELS_TO_UNLOCK_FEATURES.CARGO_CARS;
}

export function isWarehouseLocked(state) {
	return levelSelectors.getLevelNumber(state) < LEVELS_TO_UNLOCK_FEATURES.WAREHOUSES;
}

export function isPlayerHealthBarLocked(state) {
	return levelSelectors.getLevelNumber(state) < LEVELS_TO_UNLOCK_FEATURES.PLAYER_HEALTH;
}

export function isFinancialRatiosLocked(state) {
	return levelSelectors.getLevelNumber(state) < LEVELS_TO_UNLOCK_FEATURES.FINANCIAL_RATIOS_VIEW;
}

export function getsellingPricesChanged(state) {
	return state.ui.sellingPricesChanged;
}

export function getDraggablesVisibility(state) {
	return state.ui.draggableComponentsVisibility;
}

export function isComponentVisible(state, componentName) {
	return state.ui.draggableComponentsVisibility[componentName];
}

export function getCurrentActiveComponentName(state) {
	return state.ui.activeComponents[0];
}

export function getActiveFinancialStatementTutorial(state) {
    const statementOnDisplay = financialStatementsSelectors.getDisplayedStatement(state);

    if (statementOnDisplay === FINANCIAL_STATEMENTS_TABS.INCOME_STATEMENT) {
        return state.ui.activeIncomeStatementTutorial;
    }

    if (statementOnDisplay === FINANCIAL_STATEMENTS_TABS.BALANCE_SHEET) {
        return state.ui.activeBalanceSheetTutorial;
    }

	if (statementOnDisplay === FINANCIAL_STATEMENTS_TABS.FINANCIAL_RATIOS) {
		return state.ui.activeFinancialRatiosTutorial;
	}

    return null;
}

export function isFinancialStatementTutorialAutomated(state) {
	return state.ui.isFinancialStatementTutorialAutomated;
}

export function shouldShowNewCustomerTypeHint(state) {
	return state.ui.hasPendingCustomerTypeHint;
}

export function shouldShowLevelStory(state) {
	return state.ui.shouldShowLevelStory;
}

export function hasClosedNewLevelModal(state) {
	return state.ui.hasClosedNewLevelModal;
}

export function getLogbookDefaultTab(state) {
	if (getCurrentActiveComponentName(state) === COMPONENTS_NAMES.PROCUREMENT) {
		return LOGBOOK_TABS.PURCHASES;
	}

	if (turnSelectors.isCustomersPhase(state)) {
		return LOGBOOK_TABS.SALES;
	}

	return LOGBOOK_TABS.GENERAL;
}

export function shouldShowAnimationForKeychain(state) {
	const level = levelSelectors.getLevelNumber(state);

	const isCarUnlockLevel = level === LEVELS_TO_UNLOCK_FEATURES.CARGO_CARS;
	const isWarehouseUnlockLevel = level === LEVELS_TO_UNLOCK_FEATURES.WAREHOUSES;

	if (!(isCarUnlockLevel || isWarehouseUnlockLevel)) {
		return false;
	}

	const shouldLeviatateForCars = 
		shouldShowAnimationForDeskItem(state, LEVELS_TO_UNLOCK_FEATURES.CARGO_CARS);

	if (shouldLeviatateForCars) {
		return true;
	}

	const shouldLeviatateForWarehouse =
		shouldShowAnimationForDeskItem(state, LEVELS_TO_UNLOCK_FEATURES.WAREHOUSES);

	return shouldLeviatateForWarehouse;
}

export function shouldShowAnimationForDeskItem(state, levelToUnlockFeature) {
	if (!hasClosedNewLevelModal(state)) {
		return false;
	}

	const level = levelSelectors.getLevelNumber(state);
	const isLevelForUnlockingItem = level === levelToUnlockFeature;

	if (!isLevelForUnlockingItem) {
		return false;
	}

	const isFirstAttemptInLevel = levelSelectors.isFirstAttemptInLevel(state);

	if (!isFirstAttemptInLevel) {
		return false;
	}

	const isFirstTurnInLevel = levelSelectors.isFirstTurnInLevel(state);

	return isFirstTurnInLevel;
}

export function shouldShowMandatoryProfitDistributionModal(state) {
	const level = levelSelectors.getLevelNumber(state);
	const currentTurn = turnSelectors.getTurnNum(state);
	const missionStartingTurn = levelSelectors.getMissions(state)[0]?.startedInTurn;

	const isLevelOfUnlockingProfitDistribution = level === LEVELS_TO_UNLOCK_FEATURES.PROFIT_DISTRIBUTION;
	const isFirstTurnInNextQuarterAfterUnlockingProfitDistribution = currentTurn === missionStartingTurn + 3;

	if (isLevelOfUnlockingProfitDistribution && isFirstTurnInNextQuarterAfterUnlockingProfitDistribution) {
		return true;
	}
	return false;
}
